import React, {Component} from "react";
import {PRIVACY_POLICY_LINK, USAGE_TERMS_LINK} from "./sign-in-utils";
import {injectIntl} from "react-intl";

export class PrivacyAndTermsFooter extends Component {
    render(){
        const {
            intl
        } = this.props;
        return (
            <div style={{ width: "80%", margin: '0 auto', textAlign: 'center', fontSize: 13, }}>
                {intl.formatMessage({ id: 'sign_in.footer_1' })} <a href={USAGE_TERMS_LINK} target="_blank" rel="noopener noreferrer"> {intl.formatMessage({ id: 'sign_in.footer_2' })}</a> y <a href={PRIVACY_POLICY_LINK} target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: 'sign_in.footer_3' })}</a>.
            </div>
        );
    }
}

export default injectIntl(PrivacyAndTermsFooter)